import { ContentType, apiRequest } from '../../main/services/api'
import mapActionCreators from '../maps/store/action-creators'
import { Indices, updateIndices } from './indices-data'

let homepageRefresh: number

if (FinvizHomepageRefreshInterval) {
  HomepageRefreshInit(FinvizHomepageRefreshInterval)
}

function HomepageRefreshInit(refresh: number) {
  homepageRefresh = refresh * 1000
  setTimeout(HomepageRefresh, homepageRefresh)
}

function getSignalsTableStart(id: string) {
  return `<table id="${id}" width="100%" cellpadding="1" cellspacing="0" class="t-home-table" border="0">`
}

function getDataFromStartEndChar(str: string, startStr: string, endStr: string) {
  let start = str.indexOf(startStr)
  if (start < 0) return
  start += startStr.length
  const end = str.indexOf(endStr, start)
  if (end < 0) return

  return str.substring(start, end)
}

function getDataFromVariableName(str: string, variableName: string) {
  const value = getDataFromStartEndChar(str, `var ${variableName} = `, ';')

  if (!value) return

  return JSON.parse(value)
}

function OnHomepageRefresh(result: string) {
  // Check indexVersion and reload if it’s different. `FinvizIndexVersion` is
  // defined in index.cs
  const indexVersion = getDataFromStartEndChar(result, 'var FinvizIndexVersion="', '"')
  if (indexVersion !== FinvizIndexVersion) {
    window.location.reload()
  }

  // Check userId and do not continue if it changed. `userId` is defined in index.cs
  const userIdNew = getDataFromStartEndChar(result, 'var userId="', '"')
  if (userIdNew !== userId) {
    return
  }

  // Replace left signals table
  const signals1El = document.getElementById('signals_1')
  const signals1 = getDataFromStartEndChar(result, getSignalsTableStart('signals_1'), '</table>')
  if (signals1El && signals1) {
    signals1El.innerHTML = signals1
  }

  // Replace right signals table
  const signals2El = document.getElementById('signals_2')
  const signals2 = getDataFromStartEndChar(result, getSignalsTableStart('signals_2'), '</table>')
  if (signals2El && signals2) {
    signals2El.innerHTML = signals2
  }

  // Replace right signals table
  const homepageBottomEl = document.getElementById('homepage_bottom')
  const homepageBottom = getDataFromStartEndChar(result, '<div id="homepage_bottom">', '</div>\n')
  if (homepageBottomEl && homepageBottom) {
    homepageBottomEl.innerHTML = homepageBottom
  }

  // Update indices
  const indicesData = getDataFromStartEndChar(result, '<script id="js-indices" type="application/json">', '</script>')
  updateIndices(JSON.parse(indicesData!) as Indices)

  // Render maps
  const perfDataSec = getDataFromVariableName(result, 'perfDataSec')
  const perfDataGeo = getDataFromVariableName(result, 'perfDataGeo')

  try {
    mapActionCreators.updatePerfData(window.FinvizIndexSecMap, perfDataSec)
    mapActionCreators.updatePerfData(window.FinvizIndexGeoMap, perfDataGeo)
  } catch {}

  /**
   * Re-render recent quotes. The script (recent_quotes.js) is only included for premium users
   * so we need to check if it's defined
   */
  if (typeof window['RenderRecentQuotes'] === 'function') {
    RenderRecentQuotes()
  }

  // Send refresh event to google analytics
  window.gtag?.('event', 'refresh', { event_category: 'page' })
  // Refresh any ads that might be on the page
  if (window.finvizBannersLoaded === true) {
    window.initFinvizBanners?.()
  } else if (typeof window.refreshAds === 'function') {
    window.refreshAds('#homepage_bottom [id*=IC_D_]')
  }
}

async function HomepageRefresh() {
  const data = await apiRequest<string>(window.location.pathname, {
    headers: { 'Content-Type': ContentType.Html },
  })
  if (data) {
    OnHomepageRefresh(data)
  }
  setTimeout(HomepageRefresh, homepageRefresh)
}
